import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	priorityStockFlagContainer: {
		maxWidth: "120px",
		height: "25px",
		marginTop: "2px",
		fontSize: "0.85rem",
		lineHeight: "1.9",
	},
	iconContainer: {
		"& svg": {
			height: "20px",
		},
		padding: theme.spacing(0.2, 0.2, 0, 0.2),
	},
	recallTag: {
		backgroundColor: `${theme.palette.custom.priorityFlagColors.recall}`,
		color: "#fff",
	},
	newReleaseTag: {
		backgroundColor: `${theme.palette.custom.priorityFlagColors.newRelease}`,
		color: "#fff",
	},
	embargoTag: {
		backgroundColor: `${theme.palette.custom.priorityFlagColors.embargo}`,
		color: "#fff",
	},
	preOrderTag: {
		backgroundColor: `${theme.palette.custom.priorityFlagColors.preOrder}`,
		color: "#000",
	},
	highPriorityTag: {
		backgroundColor: `${theme.palette.custom.priorityFlagColors.highPriority}`,
		color: "#fff",
	},
	recallTagAccordion: {
		borderBottom: `1px solid ${theme.palette.custom.priorityFlagColors.recall}`,
	},
	newReleaseTagAccordion: {
		borderBottom: `1px solid ${theme.palette.custom.priorityFlagColors.newRelease}`,
	},
	embargoTagAccordion: {
		borderBottom: `1px solid ${theme.palette.custom.priorityFlagColors.embargo}`,
	},
	preOrderTagAccordion: {
		borderBottom: `1px solid ${theme.palette.custom.priorityFlagColors.preOrder}`,
	},
	highPriorityTagAccordion: {
		borderBottom: `1px solid ${theme.palette.custom.priorityFlagColors.highPriority}`,
	},
	accordion: {
		boxShadow: "none",
		"&:before": {
			display: "none",
		},
	},
	accordionSummary: {
		padding: 0,
		minHeight: "auto !important",
		"&.MuiAccordionSummary-root.Mui-expanded": {
			minHeight: "auto !important",
		},
		"& .MuiAccordionSummary-content": {
			margin: "0 0 -1px 0 !important",
			"&.Mui-expanded": {
				margin: "0 0 -1px 0 !important",
			},
		},
		"& .MuiAccordionSummary-expandIcon": {
			padding: "5px 12px",
		},
	},
	accordionDetails: {
		padding: "8px 0px",
		fontWeight: 400,
	},
	flagTagBox: {
		fontSize: "0.975rem",
		lineHeight: 1.3,
		fontWeight: 500,
	},
	flagTagIcon: {
		padding: theme.spacing(0.6, 0.7, 0, 0.7),
	},
	divider: {
		margin: "6px 0",
	},

	typographyBody2: {
		fontWeight: 400,
	},
	purchaseOrderPriorityStockTextContainer: {
		width: "100%",
	},
	typographySubtitle2: {
		fontWeight: 400,
	},
}));
